import { extendObservable } from 'mobx'
import pick from 'lodash/pick'

import { employeeApi, segmentApi } from '@atheneum/api'

class SegmentFormStore {
  constructor (staticData, segment, project) {
    extendObservable(this, {
      staticData,
      segment,
      project,
      employees: [],
      loading: false
    })

    this.loadEmployees()
    this.reorderScreeningQuestions()
  }

  async loadEmployees () {
    this.loading = true
    const relevantEmployeeIds = this.segment
      ? this.segment.employees.map(e => e.id)
      : []
    const { EMPLOYEE_POSITIONS } = this.staticData.CONST
    const positions = [
      EMPLOYEE_POSITIONS.ASSOCIATE,
      EMPLOYEE_POSITIONS.TEAM_LEADER,
      EMPLOYEE_POSITIONS.ASSOCIATE_INTERN,
      EMPLOYEE_POSITIONS.ACCOUNT_MANAGER
    ]
    let employees = await employeeApi.getByPosition(
      positions,
      relevantEmployeeIds
    )
    employees = employees.map(e => {
      return {
        id: e.id,
        fullName: e.fullName,
        active: !!e.status,
        positionId: e.employeePositionId
      }
    })
    this.employees.replace(employees)
    this.loading = false
  }

  reorderScreeningQuestions () {
    if (!(this.segment && this.segment.screeningQuestionsOrder && this.segment.screeningQuestions.length)) return
    const orderedIds = this.segment.screeningQuestionsOrder
        .split(', ')
        .filter(x => !!this.segment.screeningQuestions.find(q => q.id === Number(x)));
    const reorderedQuestions = orderedIds
      .map(id => {
        return {
          id,
          question: this.segment.screeningQuestions.find(
            q => q.id === Number(id)
          ).question
        }
      })
    this.segment.screeningQuestions.replace(reorderedQuestions)
  }

  typeahead = (q, key) => {
    return segmentApi.typeahead(q, key).then(segments => ({
      options: segments.map(segment => {
        return { value: segment.id, label: segment.name }
      })
    }))
  }

  create (data) {
    const segmentData = this.prepareDataForApi(data)
    return segmentApi.create(segmentData)
  }

  update (id, data) {
    const segmentData = this.prepareDataForApi(data)
    return segmentApi.update(id, segmentData)
  }

  prepareDataForApi = data => {
    return {
      employees: data.employees.map(e => e.id),
      screeningQuestions: data.screeningQuestions.filter(
        sq => sq.question !== ''
      ),
      ...pick(data, [
        'complete',
        'name',
        'numberOfExpert',
        'projectId',
        'expertBrief',
        'disclaimer1',
        'disclaimer2'
      ])
    }
  }
}

export default SegmentFormStore
